let disableScroll = false;

class BrandLetterLink extends HTMLElement {
  constructor() {
    super();

    this.letter = this.getAttribute('data-letter');
    this.link = this.querySelector('a');
    this.link.addEventListener('click', (event) => {
      event.preventDefault();
      BrandLetterLink.scrollToLetter(this.link);
      disableScroll = true;
    });
  }

  static scrollToLetter(letter) {
    const content = document.querySelector(
      `brand-letter-content[letter="${letter}"]`
    );

    if (!content) return;
    content.scrollToSelf();
  }
}

class BrandLetterContent extends HTMLElement {
  constructor() {
    super();

    this.scrollToSelf = this.scrollToSelf.bind(this);
  }

  scrollToSelf() {
    const header = document.querySelector('.section-header');
    const headerHeight = header.getBoundingClientRect().height;
    const offsetY = this.getBoundingClientRect().top - headerHeight;
    window.scrollBy(0, offsetY);
  }
}

defineCustomElement('brand-letter-content', BrandLetterContent);
defineCustomElement('brand-letter-link', BrandLetterLink);

document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.hash) return;
  BrandLetterLink.scrollToLetter(window.location.hash.replace('#', ''));
});

window.addEventListener('hashchange', () => {
  const anchor = window.location.hash.replace('#', '');
  if (disableScroll) {
    disableScroll = false;
    return;
  }

  BrandLetterLink.scrollToLetter(anchor);
});
